/* eslint-disable no-undef */
/**
 * This is the main entry point for the constructor.
 */
import '~base';
import processInclude from 'base/util';
import $ from 'jquery';

$(document).ready(() => {
  processInclude(require('./constructor/userInfo'));
  processInclude(require('./constructor/recommendations'));
});
